// extracted by mini-css-extract-plugin
module.exports = {"container":"_1-HJgOD-bCFrhfMxm-9Jt6"};